import * as B from "lonna"

export function editAtom<A>(source: B.Property<A>): [B.Atom<A>, () => void] {
  const localValue = B.atom<A | undefined>(undefined)
  const cancel = () => localValue.set(undefined)
  const value = B.combine(source, localValue, (s, l) => (l !== undefined ? l : s))
  return [B.atom(value, localValue.set), cancel]
}
